import { render, staticRenderFns } from "./IncoTermCodeList.vue?vue&type=template&id=55f4efa2&scoped=true&"
import script from "./IncoTermCodeList.vue?vue&type=script&lang=js&"
export * from "./IncoTermCodeList.vue?vue&type=script&lang=js&"
import style0 from "./IncoTermCodeList.vue?vue&type=style&index=0&id=55f4efa2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f4efa2",
  null
  
)

export default component.exports